export default __webpack_public_path__ + "static/media/D99BC872-FF65-48B2-90EB-43C98B6D6E07_4_5005_c.7f9f828e.jpeg";